import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { isObject } from 'lodash'
import css from '../../css/gif-tags.css'
const { array, shape } = PropTypes

import { getExplorePath } from 'shared/util/search'

const GifTag = ({ tag }) => {
    // make tags work for both string and object responses
    // this is due to a difference in format between initial
    // template gif data and paginated API response data
    const text = isObject(tag) ? tag.text : tag
    return (
        <a className={css.tag} href={getExplorePath(text)}>
            {text}
        </a>
    )
}

const GifTags = ({ gif: { tags } }) => {
    return <div className={css.tags}>{tags ? tags.map((tag, index) => <GifTag key={index} tag={tag} />) : null}</div>
}

GifTags.propTypes = {
    gif: shape({
        tags: array,
    }),
}

export default GifTags
